module.exports = __webpack_public_path__ + "static/media/coffee_mobile_en.32fb6767.jpg";